import type { SupportedLanguage } from '~/constants/languages';
import type { PaymentMethodVariables } from '~/types/payment';

export const findLanguagePaymentNames = (
  language: SupportedLanguage
): PaymentMethodLanguageMap | null => {
  const paymentName = paymentMethodLanguageMap[language];
  if (!paymentName) {
    return null;
  }
  return paymentName;
};

export type PaymentMethodLanguageMap = Record<PaymentMethodVariables, string>;

export type PaymentMethodLanguageMaps = Record<
  Exclude<SupportedLanguage, 'ja'>,
  PaymentMethodLanguageMap
>;

export const paymentMethodLanguageMap: PaymentMethodLanguageMaps = {
  en: {
    credit: 'Credit Card',
    paypay: 'PayPay',
    'carriers:au': 'Carrier Billing',
    'carriers:docomo': 'Carrier Billing',
    'carriers:softbank': 'Carrier Billing',
    unionpay: 'UnionPay',
    'alipay+': 'AliPay+',
    applepay: 'Apple Pay',
    googlepay: 'Google Pay',
    play_ticket: 'Play Ticket',
  },
  'zh-CN': {
    credit: '信用卡',
    paypay: 'PayPay',
    'carriers:au': '运营商计费',
    'carriers:docomo': '运营商计费',
    'carriers:softbank': '运营商计费',
    unionpay: '银联支付',
    'alipay+': '支付宝+',
    applepay: 'Apple Pay',
    googlepay: 'Google Pay',
    play_ticket: 'Play 票',
  },
  'zh-TW': {
    credit: '信用卡',
    paypay: 'PayPay',
    'carriers:au': '運營商計費',
    'carriers:docomo': '運營商計費',
    'carriers:softbank': '運營商計費',
    unionpay: '銀聯',
    'alipay+': '支付寶+',
    applepay: 'Apple Pay',
    googlepay: 'Google Pay',
    play_ticket: '遊戲票',
  },
  kr: {
    credit: '신용카드',
    paypay: 'PayPay',
    'carriers:au': '통신사 결제',
    'carriers:docomo': '통신사 결제',
    'carriers:softbank': '통신사 결제',
    unionpay: '유니온페이',
    'alipay+': '알리페이+',
    applepay: 'Apple Pay',
    googlepay: 'Google Pay',
    play_ticket: 'Play 티켓',
  },
};
